import React, { FormEvent, useState } from 'react';
import { useHistory } from 'react-router-dom';
import LoginCarousel from '../shared/components/LoginCarousel';
import LoginFooter from '../shared/components/LoginFooter';
import { encryptData, saveToLocal } from '../utilities/authUtils';

import './login.css';

export default function Login() {
  const history = useHistory();

  const [fields, setField] = useState({ userName: '', password: '' });
  const [errors, setErrors] = useState({ userName: false, password: false });
  const [globalError, setGlobalError] = useState('');
  let formFields = {};

  const validateForm = () => {
    let formIsValid = true;
    const encryptedUserName = encryptData(fields['userName']);
    const encryptedPassword = encryptData(fields['password']);

     formFields = {
      encryptedUserName,
      encryptedPassword,
    };
    if (!fields['userName']) {
      formIsValid = false;
      errors['userName'] = true;
    }

    if (!fields['password']) {
      formIsValid = false;
      errors['password'] = true;
    }
    setErrors({...errors});
    return formIsValid;
  };

  const onSubmitHandler = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formFields),
    };

    fetch(process.env.REACT_APP_API_BASE_URL + 'Provider/Insurer/Login', requestOptions)
      .then((response) => response.json())
      .then((data) =>
        data.accessToken
          ? saveToLocal(data.accessToken, data, history)
          : setGlobalError(data.errorMessage),
      )
      .catch((err: Error) => setGlobalError(err.message));
  };

  const onTextChange = (ev: any): any => {
    setGlobalError('');
    setErrors({userName: false, password: false});
    setField({ ...fields, ...{ [ev.target.name]: ev.target.value } });
  };

  return (
    <React.Fragment>
      <div className="main-wrap">
        <LoginCarousel />
        <div className="login-box">
          <img src={require('../assets/img/ihx-logo.svg')} alt="IHX" />
          <p className="welocme-text">Welcome to IHX</p>

          <form onSubmit={onSubmitHandler} style={{ width: '100%' }}>
            <p className="title">Sign in</p>
            <div className="form-group">
              <input
                type="text"
                className={['form-control', errors.userName ? 'error' : ''].join(' ')}
                name="userName"
                placeholder="Username or Email"
                onChange={onTextChange}
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                name="password"
                className={['form-control', errors.password ? 'error' : ''].join(' ')}
                placeholder="Password"
                onChange={onTextChange}
              />
            </div>
            <div className="error-message">{globalError}</div>
            <button type="submit" className="btn-primary">
              Sign in
            </button>
          </form>
          <div className="mobile__login-footer">
            <LoginFooter/>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
